import { cn } from "@/lib/utils";

interface HeadersTableProps {
  headers: Array<{ name: string; value: string }>;
  className?: string;
  size?: "sm" | "xs";
}

export function HeadersTable({
  headers,
  className,
  size = "sm",
}: HeadersTableProps) {
  if (headers.length === 0) {
    return null;
  }

  const textSizeClass = size === "xs" ? "text-xs" : "text-sm";

  return (
    <div className={cn("", className)}>
      <div className="grid grid-cols-2 border-b border-border">
        <div className={cn("py-2 text-foreground", textSizeClass)}>Name</div>
        <div className={cn("py-2 text-foreground", textSizeClass)}>Value</div>
      </div>
      {headers.map((header, index) => (
        <div
          key={`${header.name}-${header.value}`}
          className={cn(
            "grid grid-cols-2",
            index !== headers.length - 1 && "border-b border-border",
          )}
        >
          <div
            className={cn(
              "py-2 font-mono text-muted-foreground",
              textSizeClass,
            )}
          >
            {header.name}
          </div>
          <div
            className={cn(
              "py-2 font-mono text-muted-foreground",
              textSizeClass,
            )}
          >
            {header.value}
          </div>
        </div>
      ))}
    </div>
  );
}
